import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, Mail, ChevronDown } from "lucide-react";
import { COMPANY, NAV } from "../data/mock";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50">
      {/* Top strip */}
      <div className="top-bar hidden md:block">
        <div className="lis-container flex items-center justify-between py-2">
          <div className="flex items-center gap-6">
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white">
              <Mail size={14} /> {COMPANY.email}
            </a>
            <a href={`tel:${COMPANY.phones[0].replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-white">
              <Phone size={14} /> {COMPANY.phones[0]}
            </a>
            <a href={`tel:${COMPANY.phones[1].replace(/\s/g, "")}`} className="hidden lg:flex items-center gap-2 hover:text-white">
              <Phone size={14} /> {COMPANY.phones[1]}
            </a>
          </div>
          <div className="text-xs text-slate-300">ISO Consulting  Training  Certification Support  Audits</div>
        </div>
      </div>

      {/* Main nav */}
      <div className={`bg-white ${scrolled ? "nav-shadow" : ""}`}>
        <div className="lis-container flex items-center justify-between py-3">
          <Link to="/" className="flex items-center gap-3 py-1">
            <img src={COMPANY.logo} alt="LIS Logo" className="h-11 md:h-14 w-auto object-contain" />
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((item) => (
              <div key={item.label} className="nav-item relative">
                <Link
                  to={item.to}
                  className={`px-3 py-2 text-[14px] font-medium rounded-md flex items-center gap-1 hover:text-brand transition-colors ${
                    location.pathname === item.to ? "text-brand" : "text-slate-700"
                  }`}
                >
                  {item.label}
                  {item.children && <ChevronDown size={14} className="opacity-70" />}
                </Link>
                {item.children && (
                  <div className="mega-menu">
                    {item.children.map((c) => (
                      <Link
                        key={c.label}
                        to={c.to}
                        className="block px-3 py-2 rounded-md text-[13.5px] text-slate-700 hover:bg-red-50 hover:text-brand"
                      >
                        {c.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <Link to="/contact" className="btn-brand text-sm">Get a Free Quote</Link>
          </div>

          <button className="lg:hidden p-2 rounded-md hover:bg-slate-100" onClick={() => setOpen(!open)} aria-label="Toggle menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="lg:hidden border-t border-slate-100 bg-white">
            <div className="lis-container py-3 flex flex-col gap-1">
              {NAV.map((item) => (
                <Link key={item.label} to={item.to} className="py-2 text-slate-700 font-medium hover:text-brand">
                  {item.label}
                </Link>
              ))}
              <Link to="/contact" className="btn-brand justify-center mt-2">Get a Free Quote</Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
